import React, { useState, useContext, useEffect, useCallback } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography, TextareaAutosize } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { getTZDateAsString } from '../utils/DateUtils';
import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import '../App.css';

const MOTDList = () => {
  const [defaultMessage, setDefaultMessage] = useState('');
  const [motds, setMotds] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  
  useEffect(() => {
    const onFetchSuccess = (motd) => {
      if (motd !== null) {
        setDefaultMessage(motd.motd);
      }
    };

    const fetchMotd = async () => {
      const params = {
        _site: user._site._id
      };
      rpc({
        method: 'GetDefaultMotd',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };
    fetchMotd();
  }, [user]);

  const fetchMotds = async () => {
    const mdate = DateTime.now().setZone(user._site.timezone).startOf('day');
    const dateStr = mdate.toISODate(); 

    const params = {
      _site: user._site._id,
      datestr: { $gte: dateStr },
    };

    rpc({
      method: "GetMotds",
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess: setMotds
    });
  };
  const fetch = useCallback(fetchMotds, [user]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const onCreate = () => {
    navigate('/createMotd');
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const handleMessageChange = (event) => {
    setDefaultMessage(event.target.value);
  };

  const updateMotd = async () => {
    if (defaultMessage === '') {
      setErrorMessage('Message field is required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _site: user._site._id,
      motd: defaultMessage,
    };
    rpc({
      method: 'UpdateDefaultMotd',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess: () => {
        // Optionally refresh or show success
      }
    });
  };

  return (
    <div className="MOTDList">
      <Typography variant="h6" gutterBottom>
        Message Of The Day
      </Typography>
      <Typography variant="h8" gutterBottom sx={{ fontWeight: 'bold' }}>
        Default Message
      </Typography>
      <TextareaAutosize
        className="TextareaAutosize"
        aria-label="Default Message"
        placeholder="Enter default message here"
        minRows={3}
        value={defaultMessage}
        onChange={handleMessageChange}
      />
      <Button className="Button" variant="contained" color="primary" onClick={updateMotd}>
        Save
      </Button>
      <TableContainer className="TableContainer" component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Message Date</b></TableCell>
              <TableCell><b>Message</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {motds.map((motd, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Link to={`/motd/${motd._id}`}>{getTZDateAsString(motd.date, user._site.timezone)}</Link>
                </TableCell>
                <TableCell>{motd.motd}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="HorizontalContainer">
        <Button className="Button" variant="contained" color="primary" onClick={onCreate}>
          Create
        </Button>
      </div>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default MOTDList;
